import React, { useState } from "react"
import { Link } from "gatsby"

import ImageModule from "../../modules/image_module";
import CTABtnModule from "../../modules/cta_btn_module";
import { PageLinks } from "../../common/page-links";

import "./CarousalCard.scss";

const CarousalCard = ({item, GQLPage}) => {

    const ImageRenderList = ({imagename }) => {
        let processedImages = JSON.stringify({});
        if (GQLPage?.imagetransforms?.Image_Text_Carousel_image_Transforms) {
            processedImages = GQLPage?.imagetransforms?.Image_Text_Carousel_image_Transforms;
        }
        return (
            <ImageModule ImageSrc={item.image} title={item.title} altText={item.title} imagetransforms={processedImages} ggfx_results={GQLPage?.ggfx_results} renderer="srcSet" imagename={imagename} strapi_id={GQLPage.id} loading="lazy" />
        )
    }

    return (
        <React.Fragment>
            <div className="carousal-wrapper">
                <div className="carousal-img ">
                    <ImageRenderList item={item} imagename={"pages.Image_Text_Carousel_image.scroll_image"} />
                </div>
                <div className="carousal-content">
                    <h3>{item.title}</h3>
                    <p>{item.content}</p>
                    <CTABtnModule button_cta={item.button_cta} />
                </div>
            </div>

        </React.Fragment>
    );
};
export default CarousalCard;
